import React, {useEffect} from "react";
import {Col, Form, Row, Button, ButtonGroup } from "react-bootstrap";
import { MdOutlinePix } from "react-icons/md";
import { useForms } from "./../../use-forms/index"
import cpfCnpj from "pages/registers/helpers/cpf-cnpj-helper";
import phoneNumber from "pages/registers/helpers/phone-number-helper";
import { z } from "zod"

const formSchema = z.object({
  pix_key_type: z.string().nonempty("Tipo de chave pix é obrigatório."),
  pix_key: z.string().nonempty("Chave pix é obrigatório.")
})

//Form step 4
function Index(props) {
  const {
    register,
    setValue,
    setError,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForms({ validator: formSchema })

  useEffect(() => {
    clearErrors()
    setValue('pix_key', props.form.pix_key)
    setValue('pix_key_type', props.form.pix_key_type)
  }, [])

  const onSubmitForm = data => {
    //post or validate data to/on api endpoint here
    const validations = {
      'CPF': (
        data.pix_key_type == 'CPF' &&
        cpfCnpj.unmask(data.pix_key?.length) === 11
      ),
      'CNPJ': (
        data.pix_key_type == 'CNPJ' &&
        cpfCnpj.unmask(data.pix_key?.length) === 14
      ),
      'CELULAR': (
        data.pix_key_type == 'CELULAR' &&
        (phoneNumber.unmask(data.pix_key?.length) === 11 || phoneNumber.unmask(data.pix_key?.length) === 12)
      ),
      'EMAIL': (
        data.pix_key_type == 'EMAIL' &&
        data.pix_key.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      ),
      'CHAVE_ALEATORIA': false
    }

    //!validations[data.pix_key_type] && data.pix_key_type !== 'CHAVE_ALEATORIA'
    if (!validations[data.pix_key_type]) {
      return setError('pix_key', {message: 'Chave PIX inválida para o tipo selecionado.'})
    }

    //on success
    props?.submit(data)
  }

  return (
    <Form onSubmit={handleSubmit(onSubmitForm)} className="col-12 col-md-6 col-lg-4">
      <div className="background"></div>
      <h2 className="mb-3"><MdOutlinePix/> Chave PIX</h2>
      <p>Preencha os campos correspondentes às sua chave de PIX, e salve para continuar.</p>
      <Row>
        <Form.Group as={Col} className="mb-3 col-12">
          <Form.Label column sm="5">
            Tipo de Chave PIX
          </Form.Label>
          <Form.Select placeholder="Tipo de chave" aria-label="Tipo de chave" {...register('pix_key_type')}>
            <option defaultValue={null}>Tipo de chave</option>
            <option value="CPF">CPF</option>
            <option value="CNPJ">CNPJ</option>
            {/* <option value="CHAVE_ALEATORIA">Chave Aleatória</option> */}
          </Form.Select>
          {errors.pix_key_type?.message && <div className="text-danger">{errors.pix_key_type?.message}</div>}
        </Form.Group>

        <Form.Group as={Col} className="mb-3 col-12">
          <Form.Label column sm="5">
            Chave PIX
          </Form.Label>
          <Col sm="12">
            <Form.Control type="text" {...register('pix_key')} maxLength={20} />
            {errors.pix_key?.message && <div className="text-danger">{errors.pix_key?.message}</div>}
          </Col>
        </Form.Group>
      </Row>

      <ButtonGroup className="col-12 mt-5">
        <Button onClick={props?.back} className="btn btn-light btn-large" type="button">Voltar</Button>
        <Button className="btn btn-primary btn-large centerButton" type="submit">Salvar</Button>
      </ButtonGroup>
    </Form>
  );
}

export default Index;